
import { Component, Vue } from "vue-property-decorator";
@Component
export default class PreferentialHouse extends Vue {
  render() {
    return (
      <div>
        <div class="perferential-house">
          <h2 class="title">特惠房源</h2>
          <div style="height:10px;"></div>
          <a-row>
            <a-col span={15} style="padding:0px 20px">
              <div class="perhouse-item">
                <img src={require("@/assets/xkj.png")} />
                <div class="item-dec">
                  <div>温馨小开间</div>
                  <div>万年花城三期一室一厅</div>
                </div>
              </div>
            </a-col>
            <a-col span={9} style="padding-right:20px">
              <a-row>
                <a-col>
                  <div class="perhouse-item item-min">
                    <img src={require("@/assets/xkj-r1.png")} />
                    <div class="item-dec">
                      <div>温馨小开间</div>
                      <div>万年花城三期一室一厅</div>
                    </div>
                  </div>
                </a-col>
                <div style="height:20px;"></div>
                <a-col>
                  <div class="perhouse-item item-min">
                    <img src={require("@/assets/xkj-r2.jpg")} />
                    <div class="item-dec">
                      <div>温馨小开间</div>
                      <div>万年花城三期一室一厅</div>
                    </div>
                  </div>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <div style="height:20px;"></div>
          <a-button class="ty-btn-ghost" ghost style="border-radius:18px;">
            更多房源 &gt;
          </a-button>
        </div>
      </div>
    );
  }
}
